// extracted by mini-css-extract-plugin
module.exports = {"emptyForm":"empty-form_emptyForm__3DBZt","image":"empty-form_image__2-jii","text":"empty-form_text__2wuJm"};